// extracted by mini-css-extract-plugin
export default {"ridesCardsWrapper":"CardArea_ridesCardsWrapper__bAcz6"};